import { Component, OnInit } from '@angular/core';
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { HomeService } from '../../../pages/home/services/home.service';
import { OfficeService } from '../../../pages/office/services/office.service';
import { Router } from '@angular/router';
import { OfficeDataService } from '../../../pages/office/services/office-data.service';
import { UtilityService } from '../../../core/services/utility.service';
import { HostListener } from '@angular/core';

@Component({
  selector: 'app-office-nav',
  templateUrl: './office-nav.component.html',
  styleUrls: ['./office-nav.component.css'],
})
export class OfficeNavComponent implements OnInit {
  portalSettings: any;
  employeeInfo: any;
  formData: { [key: string]: any } = {};
  image: any = null;
  showImageNow: boolean;
  pRCO: number;
  portalName: string;
  loginMode: string;
  isOver: boolean;
  logoUrl: string;
  companyList = [];
  groupedFormList = [];
  selectedFormList = [];
  shortMenu: boolean;

  constructor(
    private portalSettingsService: PortalSettingsService,
    private employeeInfoService: EmployeeInfoService,
    private router: Router,
    private homeService: HomeService,
    private officeService: OfficeService,
    public officeDataService: OfficeDataService,
    private utilityService: UtilityService
  ) {
    portalSettingsService.portalSettings$.subscribe(latestSettings => {
      this.portalSettings = latestSettings;
    });
    this.employeeInfo = this.employeeInfoService.getEmployeeInfo();
  }

  ngOnInit(): void {
    this.shortMenu = window.innerWidth < 500;
    this.utilityService.openModal();
    this.officeDataService.OfficeNavBarOn = true;
    this.getCompany();
    this.getUserContext();
  }

  private getCompany() {
    this.officeService.getCompanies().then((response: any) => {
      this.companyList = response;
      this.officeDataService.SGFCompanyList = this.companyList;
      if (response != null) {
        var count = 0;
        this.companyList.forEach((val, key) => {
          if (val.IsDefault) {
            count++;
            this.formData.selectedCompany = val.HQCo;
          }
        });
        if (count == 0) {
          this.formData.selectedCompany = this.companyList[0].HQCo;
        }
        this.officeDataService.SGFCompany = this.formData.selectedCompany;
        this.getForm();
      }
    });
  }

  private getForm() {
    this.selectedFormList = [];
    this.groupedFormList = [];
    this.officeService.getForms(this.formData.selectedCompany, null).then((response: any) => {
      this.officeDataService.SGFFormList = response;
      var tempObject = {};
      var isFormExist = false;
      const groupedFormList = [];
      response.forEach((val, key) => {
        if (!tempObject.hasOwnProperty(val.ModuleLongName)) tempObject[val.ModuleLongName] = [];
        tempObject[val.ModuleLongName].push(val);

        if (window.location.pathname == '/office/maintenancegrid' && val.FormName == this.officeDataService.SGFForm) isFormExist = true;
      });

      Object.entries(tempObject).forEach((val: any, key) => {
        var tempObj = {};
        val[1].forEach((val2, key2) => {
          if (!tempObj.hasOwnProperty(val2.FormGroup)) tempObj[val2.FormGroup] = [];
          tempObj[val2.FormGroup].push(val2);
        });

        groupedFormList.push({ groupDisplay: val[0], formList: Object.values(tempObj) });
      });

      //add inquiries
      groupedFormList.push({ groupDisplay: 'Inquiries', formList: [] });
      this.groupedFormList = groupedFormList.sort((a, b) => {
        return a.groupDisplay > b.groupDisplay ? 1 : -1;
      });
      this.utilityService.closeModal();
      if (isFormExist) {
        this.officeDataService.boradcast('updateForm');
      } else {
        this.officeDataService.boradcast('removeForm');
      }
    });
  }

  public groupSelected(groupData: any) {
    if (groupData.groupDisplay == 'Inquiries') {
      this.router.navigate(['/office/inquiries']);
      $('#navbarMenu').removeClass('show');
    } else {
      this.selectedFormList = groupData.formList;
    }
  }

  public itemSelected(formData: any) {
    this.officeDataService.SGFCompany = this.formData.selectedCompany;
    this.officeDataService.SGFForm = formData.FormName;
    this.officeDataService.SGFTitle = formData.FormDesc;
    this.officeDataService.SGFRelatedTabGridForm = null;
    this.officeDataService.SGFRelatedFormMetadata = null;
    this.officeDataService.SGFRelatedRowDataEdit = null;
    this.officeDataService.SGFRelatedFormData = [];
    this.officeDataService.SGFRelatedCombobox = {};
    this.officeDataService.SGFCurrentRelatedFormReadOnly = false;
    this.officeDataService.SGFRelatedTabParentRowdata = null;
    $('#navbarMenu').removeClass('show');
    this.officeDataService.boradcast('updateForm');
    this.router.navigate(['/office/maintenancegrid']);
  }

  private getUserContext() {
    this.homeService.getUserContext().then((response: any) => {
      this.pRCO = response.PRCo;
      this.isOver = response.IsOver;
      this.loginMode = response.LoginMode;

      this.checkCompanyLogo();
      this.getPortalName();
    });
  }

  private getPortalName() {
    this.homeService.getPortalName(this.pRCO).then(response => {
      this.portalName = response == '' ? null : response;
    });
  }

  private checkCompanyLogo() {
    this.homeService.getCompanyLogo(this.pRCO, 's').then(response => {
      this.image = response == '' ? null : response;
      this.showImageNow = true;
      this.logoUrl = '/Company/GetLogo?co=' + this.pRCO + '&size=S';
    });
  }

  public companyChange() {
    this.utilityService.openModal();
    this.officeDataService.SGFCompany = this.formData.selectedCompany;
    //TODO - fix this spelling error
    this.officeDataService.boradcast('companyChanged');
    this.getForm();
    $('#navbarMenu').removeClass('show');
  }

  public routeToReportGateway() {
    $('#navbarMenu').removeClass('show');
    this.officeDataService.boradcast('updateReportGateway');
    this.officeDataService.RGWCat = this.selectedFormList[0][0].ModuleShortName;
    this.router.navigate(['/office/reportgateway']);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.shortMenu = window.innerWidth < 500;
  }
}
